<template>
  <div class="rs-listing__results">
    <!-- <div v-if="fetchedResults.posts" class="rs-listing__results__showing">
      Showing {{ fetchedResults.posts.length }} of {{ fetchedResults.total_posts }}
    </div> -->
    <div class="rs-listing__results__grid">
      <RSParshaListingCard
        v-for="(post, i) in fetchedResults.posts"
        :key="post.ID"
        :post="post"
        ref="card"
        @hook:mounted="
          i == fetchedResults.posts.length - 1 && onBottomCardMounted()
        "
      />
    </div>
  </div>
</template>

<script>
import RSParshaListingCard from "./RSParshaListingCard.vue";
export default {
  name: "RSResults",
  components: {
    RSParshaListingCard,
  },
  props: {
    fetchedResults: Object,
  },
};
</script>
